export default __webpack_public_path__ + "static/media/story-1.35420447.png";